const PainelPJe = () => {

    return (
        <div className="container">
            <div className="card">
                <h1>Painel PJe</h1>
                <hr />
                <a 
                    href="https://www.pje.jus.br/navegador/" 
                    target="_blank" 
                    rel="noopener noreferrer">
                        Navegador PJe
                </a>
            </div>
        </div>
    );
}
export default PainelPJe